import React from 'react'
import { Button } from 'components/Button'
import { connect } from 'react-redux'
import includes from 'lodash/includes'
import { appInstallRequest, appUninstallRequest } from '../../actions'

class InstallAppButtonContainer extends React.Component {
	constructor() {
		super()
		this.state = {
			disabled: false,
			loading: false
		}
	}
	_setLoading(state) {
		this.setState({
			disabled: state,
			loading: state
		})
	}
	_handleInstall = e => {
		const { installApp, onInstallSuccess } = this.props
		this._setLoading(true)
		installApp()

		if (typeof onInstallSuccess !== 'undefined') {
			onInstallSuccess(e)
		}
	}
	_handleUninstall = e => {
		const { uninstallApp } = this.props
		this._setLoading(true)
		uninstallApp()
	}
	componentWillReceiveProps(nextProps) {
		if (nextProps.isInstalled !== this.props.isInstalled) {
			this._setLoading(false)
		}
	}
	render() {
		const { isInstalled, size } = this.props

		return isInstalled ? (
			<Button
				icon={'remove_circle_outline'}
				type={'ghost'}
				size={size}
				disabled={this.state.loading || this.state.disabled}
				loading={this.state.loading}
				onClick={this._handleUninstall}
			>
				Uninstall app
			</Button>
		) : (
			<Button
				icon={'get_app'}
				size={size}
				disabled={this.state.loading || this.state.disabled}
				loading={this.state.loading}
				onClick={this._handleInstall}
			>
				Install app
			</Button>
		)
	}
}
const mapStateToProps = (state, ownProps) => {
	const isInstalled = includes(state.installedApps.items, ownProps.appId)
	const currentApp = state.apps.items[ownProps.appId]
	const appName = currentApp ? currentApp.name : ''
	return {
		isAuthorized: state.user.isAuthorized,
		isAdmin: state.user.isAdmin,
		appName,
		isInstalled
	}
}

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		installApp: () =>
			dispatch(
				appInstallRequest({
					id: ownProps.appId
				})
			),
		uninstallApp: () =>
			dispatch(
				appUninstallRequest({
					id: ownProps.appId
				})
			)
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(
	InstallAppButtonContainer
)



// WEBPACK FOOTER //
// ./src/containers/Buttons/InstallAppButton.js